import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'
import { SelectMesContabilidad } from 'sharedComponents/select'

const MesContabilidadFormGroup = ({ idFormato, iTouched, iError, fIsSubmitting, name, label }) => {
  return (
    <Form.Group>
      <Form.Label text={label || 'MES'} htmlFor={`${idFormato}-input-mesContabilidad`} md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name={name || 'mes'}>
          {({ field }) => (
            <SelectMesContabilidad
              {...field}
              mesFin={15}
              id='select-mesContabilidad'
              fIsSubmitting={fIsSubmitting}
              iError={iError}
              iTouched={iTouched}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MesContabilidadFormGroup)
